// extracted by mini-css-extract-plugin
export default {"loaderWrap":"_loader_loaderWrap__rAZd1","loader":"_loader_loader__1Oims"};